/* eslint-disable react/display-name */
import React from 'react';
import { ArrowCRightIcon16Light } from "../../../internal/icons2022/ArrowCRightIcon/ArrowCRightIcon16Light";
import { ArrowCRightIcon20Light } from "../../../internal/icons2022/ArrowCRightIcon/ArrowCRightIcon20Light";
import { ArrowCRightIcon24Regular } from "../../../internal/icons2022/ArrowCRightIcon/ArrowCRightIcon24Regular";
import { iconSizer } from "../../../internal/icons2022/iconSizer";
export var ForwardIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArrowCRightIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArrowCRightIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArrowCRightIcon24Regular, null);
  }
}, 'ForwardIcon');